export default "skymp5-front/2e9f16517ed0c984cf99e46376d37b13.png";